import {getSize} from 'platform/foundation';
import styled from 'styled-components';

export const ControlSectionWrapper = styled.div`
  width: 100%;
  height: ${getSize(12)};
  display: flex;
  align-items: center;
`;
